/* jshint ignore:start */
import * as globals from './globals';
/* jshint ignore:end */

// Get all post listing <article>
const articles = [...document.querySelectorAll('.post-listing article')];

// Add click event for each article
articles.forEach((article) => {
  let href = article.querySelector("a").href; // Find the href
  article.addEventListener('click', function (evt) {

    if (evt.ctrlKey) {
      evt.preventDefault();

      window.open(href, "_blank");
    } else {
      gotoURL(href);
    }    
  }); // add event listener
});

// Goto the URL :)
let gotoURL = (href) => {
  window.location.href = href;
  console.log('when does this run?')
}
 let form = document.getElementById('form')
var att = document.createAttribute('autocomplete')
att.value = "off"
form.setAttributeNode(att)






// WEBPACK FOOTER //
// ./CMS/NationalGuild/src/js/components/listing.js